/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {DragonTribeGameConfig} from "./DragonTribeGameConfig";
import {DTReelSymbolName} from "./symbols/DTReelSymbolName";

export class DragonTribeGameAssets {

    public static INTRO_BACKGROUND:string = "mainBackground";
    public static INTRO_LOGO:string = "introLogo";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_GAME_BACKGROUND:string = "fsBackground";

    public static MYS_BG:string = "MYS_BG";
    public static M_BG:string = "M_bg";
    public static M_T:string = "M_bg_top";
    public static M_B:string = "M_bg_bottom";
    public static M_S:string = "M_bg_sides";
    public static W_BG:string = "W_bg";
    public static W_T:string = "W_bg_top";
    public static W_B:string = "W_bg_bottom";
    public static W_S:string = "W_bg_sides";
    public static S_BG:string = "S_bg";
    public static S_T:string = "S_bg_top";
    public static S_B:string = "S_bg_bottom";
    public static S_S:string = "S_bg_sides";
    public static L_BG:string[] = ["L_bg_2", "L_bg_3", "L_bg_4", "L_bg_5", "L_bg_6"];

    public static WAYS_WON:string = "textWaysWon";
    public static WAY_WON:string = "textWayWon";
    public static WAYS:string = "textWays";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }

        if(stateName == null || stateName == "attention") {
            if(symbolName === "S") {
                return "S/S_land/S_land_";
            } else if(symbolName === "W") {
                return "W/W";
            } else if(symbolName === "M") {
                return "M/M";
            }
        }

        if(symbolName === "S" && stateName == "win") {
            return "S_win";
        }

        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        if(symbolName === DTReelSymbolName.STACK_WILD) {
            return [GameResources.getTextures("fullWildText")[19]];
        }
        if(symbolName === ReelSymbolName.SCATTER) {
            if(stateName === DragonTribeGameConfig.instance.SYMBOL_STATES.plus.keyword) {
                return GameResources.getTextures("S_attention").concat(GameResources.getTextures("S_plus"));
            }
        }
        return GameResources.getTextures(DragonTribeGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("numbersXWays", "fonts/bitmapfonts/NumbersXWays.fnt")
                ]
            },
            {
                //Reduce intro spritesheet to 8-bit color
                name : "intro",
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new TextureAsset("mainBackground", "sheets/intro/Main_background.jpg"),
                    new TextureAsset("riches", "sheets/intro/riches.png")
                ],
                animations : {
                    "introBg" : "intro_bg",
                    "navDot" : "intro_dot",
                    "btnLeft" : "btn_left",
                    "btnRight" : "btn_right",
                    "introProgressBar" : "control_bg",
                    "navDotRing" : "intro_dot_null"
                }
            },
            {
                name : "introHighQuality",
                assets : [
                    //Keep at 32-bit color
                    new TextureAsset("introHighQuality0", "sheets/introHighQuality/introHighQuality0.json"),
                ],
                animations : {
                    "introLogo": "introLogo",
                    "introPage0": "pageImage_1",
                    "introPage0_US": "pageImage_1_US",
                    "introPage1": "pageImage_2",
                    "introPage2": "pageImage_3",
                    "introPage3": "pageImage_4"
                }
            }
        ],

        main : [
            {
                //Reduce to 8-bit color
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ],
                animations : {
                    "rockFloor" : "background/rock_floor",
                    "foreground" : "background/foreground",
                    "reelForeground" : "background/Reel",
                    "reelForegroundFS" : "background/FS_Reel",
                    "symbolStoneExplosion" : "rock_broke/rock_broke_0"
                }
            },
            {
                //Reduce to 8-bit color
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ],
                animations : {
                    "flyDragon" : "flydragon/flydragon_",
                    "textWays" : "img_text/text_Ways",
                    "waysWonText" : "img_text/text_WaysWon",
                    "wayWonText" : "img_text/text_WayWon",
                    "multiX1" : "multi_text/multi_X1",
                    "multiX2" : "multi_text/multi_X2",
                    "multiX3" : "multi_text/multi_X3",
                    "multiX4" : "multi_text/multi_X4",
                    "multiX5" : "multi_text/multi_X5",
                    "multiX6" : "multi_text/multi_X6",
                    "introFeatureA" : "multi_text/multi_X5",
                    "introFeatureB" : "multi_text/multi_X6",
                    "fullWildText" : "full_wild_text/full_wild_text_",

                    "winStar" : "particles/star",
                    "bigWinText0" : "bigwin/bigwin_lv1",
                    "bigWinText1" : "bigwin/bigwin_lv2",
                    "bigWinText2" : "bigwin/bigwin_lv3",

                    "bigWinCoin0" : "particles/gem_blue/gem_blue_",
                    "bigWinCoin1" : "particles/gem_long/gem_long_",
                    "bigWinCoin2" : "particles/gem_round/gem_round_"
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json")
                ],
                animations : {
                    "reelBackground" : "background/Reel_background",
                    "reelBackgroundFS" : "background/FS_Reel_background",
                    "fsBackground" : "background/FS_Main_background",
                    "fsIntroPageGlow" : "mode_glow",
                    "symWin1" : "Win_1/Win_1_",
                    "symWin4" : "Win_4/Win_4_",
                    "symWin5" : "Win_5/Win_5_",
                    "symWin6" : "Win_6/Win_6_",
                    "waysRefresh" : "ways_refresh/ways_refresh_",
                    "M_expand" : "M_grow/M_grow_",
                    "reelInnerGlow" : "Reel_innegrow",
                    "reelOverGlow" : "Reel_innegrow2",
                    "bgSmoke" : "bg_smoke/bg_smoke_",
                    "bgTroch" : "bg_troch/bg_troch_",
                    "potentialGlow" : "potential_glow",
                    "reelFireIdle" : "reel_fire/reel_fire_",
                    "reelFireActive" : "fire_newspin/fire_newspin_",
                    "symbolFireExplosion" : "fire_explos/fire_explos_",
                    "eggEffect" : "W_eff/W_eff_",
                    "eggHit" : "W_hitbottom/W_hitbottom_",
                    "fullWildFire" : "full_wild_fire/full_wild_fire_",
                    "bigWinBgStar" : "bigwin/BigWin_bg1"
                }
            },
            {
                //Reduce to 8-bit color
                name : "freespin",
                assets : [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations : {
                    "plus2spins" : "text_plus2spins",
                    "fs_intro" : "FS_intro",
                    "dragonspins" : "dragonspins",
                    "fsIntroSymbolExplain" : "FS_intro_symbol",
                    "fsIntroModeA" : "modeA",
                    "fsIntroModeB" : "modeB",
                    "fsIntroBar" : "bar",
                    "dragonspinsText" : "dragonspins_text",
                    "icon_wild" : "wild_icon"
                }
            },
            {
                //Keep at 32-bit color
                name : "freespinHighQuality",
                assets : [
                    new TextureAsset("freespinHighQuality0", "sheets/freespinHighQuality/freespinHighQuality0.json")
                ],
                animations : {
                    "fs_outro" : "FS_outro"
                }
            },
            {
                //Reduce to 8-bit color
                name : "freespinIcons",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("freespinYellow0", "sheets/freespinYellow/freespinYellow0.json"),
                    new TextureAsset("freespinM30", "sheets/freespinM3/freespinM30.json"),
                    new TextureAsset("freespinM40", "sheets/freespinM4/freespinM40.json"),
                    new TextureAsset("freespinM50", "sheets/freespinM5/freespinM50.json"),
                    new TextureAsset("freespinM60", "sheets/freespinM6/freespinM60.json")
                ],
                animations : {
                    "M_wild_text" : "M_wild/M_wild_",
                    "icon_M2" : "icon_M2_W/icon_M2_W_",
                    "icon_M3" : "icon_M3_W/icon_M3_W_",
                    "icon_M4" : "icon_M4_W/icon_M4_W_",
                    "icon_M5" : "icon_M5_W/icon_M5_W_",
                    "icon_M6" : "icon_M6_W/icon_M6_W_"
                }
            },
            {
                name : "freespinJpeg",
                assets : [
                    new TextureAsset("freespinJpeg0", "sheets/freespinJpeg/freespinJpeg0.json"),
                ],
                animations : {
                    "meterSymbolChangeEffect" : "meter_change_bg/meter_change_bg_",
                    "addGemEffect" : "FS_gem_add/FS_gem_add_"
                },
            },
            {
                //Keep at 32-bit color
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {
                    "L_bg_2" : "L_bg/L_bg2",
                    "L_bg_3" : "L_bg/L_bg3",
                    "L_bg_4" : "L_bg/L_bg4",
                    "L_bg_5" : "L_bg/L_bg5",
                    "L_bg_6" : "L_bg/L_bg6",

                    "MYS_BG" : "M/MYS_bg",

                    "M_bg" : "M_bg/M_bg",
                    "M_bg_bottom" : "M_bg/M_FrameBottom",
                    "M_bg_sides" : "M_bg/M_FrameSides",
                    "M_bg_top" : "M_bg/M_FrameTop",

                    "S_bg" : "S_bg/S_bg",
                    "S_bg_bottom" : "S_bg/S_FrameBottom",
                    "S_bg_sides" : "S_bg/S_FrameSides",
                    "S_bg_top" : "S_bg/S_FrameTop",

                    "S_attention" : "S/S_land/S_land_",
                    "W_attention" : "W/W",
                    "M_attention" : "M/M",
                    "S_win" : "S/S_win/S_win_",
                    "S_plus" : "S/S_plus/S_plus_",

                    "W_bg" : "W_bg/W_bg",
                    "W_bg_bottom" : "W_bg/W_FrameBottom",
                    "W_bg_sides" : "W_bg/W_FrameSides",
                    "W_bg_top" : "W_bg/W_FrameTop",

                    "rockCrack0" : "W_fullreel/rock_crack_line01",
                    "rockCrack1" : "W_fullreel/rock_crack_line02"
                }
            }
        ]
    };
}
